<!-- Sidebar -->
<div id="wrapper">

    <aside id="sidebar-wrapper">

        <ul class="sidebar-nav">
            <!-- <li class="active">
                <a href="#"><i class="fa fa-home"></i>Home </a>
            </li> -->
            <!-- Home Component -->
            <li>
                <a class="nav-link" data-toggle="collapse" href="#homeDropdown" role="button" aria-expanded="false" aria-controls="homeDropdown">
                    <i class="fa-solid fa-home     "></i> MainPage <i class="fa-solid fa-caret-down"></i>
                </a>
                <div class="collapse" id="homeDropdown">
                    <ul class="nav flex-column pl-3">
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                <i class="fa-solid fa-gauge-high"></i>Dashboard<i class="fa-solid"></i></a>
                        </li>
                    </ul>
                </div>
            </li>
            <!-- Reporting component -->
            <li>
                <a class="nav-link" data-toggle="collapse" href="#reportingDropdown" role="button" aria-expanded="false" aria-controls="reportingDropdown">
                    <i class="fa-solid fa-flag"></i> Reporting <i class="fa-solid fa-caret-down"></i>
                </a>
                <div class="collapse" id="reportingDropdown">
                    <ul class="nav flex-column pl-3">
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                <i class="fa-solid fa-scroll"></i>Reports<i class="fa-solid"></i></a>
                        </li>
                    </ul>
                </div>
            </li>
            <!-- Workflow component -->
            <li>
                <a class="nav-link" data-toggle="collapse" href="#workflowDropdown" role="button" aria-expanded="false" aria-controls="workflowDropdown">
                    <i class="fa-brands fa-creative-commons-nd"></i> Workflow <i class="fa-solid fa-caret-down"></i>
                </a>
                <div class="collapse" id="workflowDropdown">
                    <ul class="nav flex-column pl-3">
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                <i class="fa-solid fa-chart-line "></i>Dashboard<i class="fa-solid"></i></a>
                        </li>
                        <li class="nav-item">

<!--                            <div class="dropdown">-->
                                <a class="nav-link"  routerLink="patient">
                                    <i class="fa-solid fa-folder-tree" style="color: #ffffff;"></i>Work Order<i class="fa-solid"></i></a>
<!--                                <div class="dropdown-menu" aria-labelledby="order">-->

<!--                                    <a class="dropdown-item"> <i class="fa-brands fa-bitbucket p-2" style="color: #444444;"></i><span class="d-none d-sm-inline">Bulk Workorder</span></a>-->
<!--                                    <a class="dropdown-item" routerLink="patient"> <i class="fa-solid fa-file-circle-plus p-2" style="color: #444444;"></i><span class="d-none d-sm-inline">Manual Workorder</span></a>-->
<!--                                </div>-->
<!--                            </div>-->
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" routerLink="userworkarea">
                                <i class="fa-solid fa-person-digging "></i>User Work Area<i class="fa-solid"></i></a>
                        </li>
                    </ul>
                </div>
            </li>
            <!-- Repository -->

            <li>
                <a class="nav-link" data-toggle="collapse" href="#repositoryDropdown" role="button" aria-expanded="false" aria-controls="repositoryDropdown">
                    <i class="fa-solid fa-database"></i> Repository <i class="fa-solid fa-caret-down"></i>
                </a>
                <div class="collapse" id="repositoryDropdown">
                    <ul class="nav flex-column pl-3">
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                <i class="fa-solid fa-file-zipper"></i>Reports<i class="fa-solid"></i></a>
                        </li>
                    </ul>
                </div>
            </li>

            <!-- Audit -->
            <li *ngIf="authService.hasAnyRole(['audit-view', 'audit-edit'])">
                <a class="nav-link" data-toggle="collapse" href="#auditDropdown" role="button" aria-expanded="false" aria-controls="auditDropdown">
                    <i class="fa-solid fa-clipboard-check"></i> Audit <i class="fa-solid fa-caret-down"></i>
                </a>
                <div class="collapse" id="auditDropdown">
                    <ul class="nav flex-column pl-3">
                        <li class="nav-item">
                            <a class="nav-link" routerLink="/audit/quality-governance" routerLinkActive="active">
                                <i class="fa-solid fa-chart-column"></i>Quality Governance Dashboard
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" routerLink="/audit/queue" routerLinkActive="active">
                                <i class="fa-solid fa-list-check"></i>Audit Queue
                            </a>
                        </li>
                    </ul>
                </div>
            </li>


            <!-- Interface -->
            <li>
                <a class="nav-link" data-toggle="collapse" href="#interfaceDropdown" role="button" aria-expanded="false" aria-controls="interfaceDropdown">
                    <i class="fa-brands fa-figma"></i> Interface <i class="fa-solid fa-caret-down"></i>
                </a>
                <div class="collapse" id="interfaceDropdown">
                    <ul class="nav flex-column pl-3">
                        <li class="nav-item">
                            <a class="nav-link" routerLink="client">
                                <i class="fa-regular fa-address-card"></i>Client Registration<i class="fa-solid"></i></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" routerLink="office">
                                <i class="fa-solid fa-building-circle-arrow-right"></i>Offices<i class="fa-solid"></i></a>
                        </li>
<!--                        <li class="nav-item">-->
<!--                            <a class="nav-link" routerLink="provider">-->
<!--                                <i class="fa-solid fa-address-card"></i>Provider Registration<i class="fa-solid"></i></a>-->
<!--                        </li>-->
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                <i class="fa-solid fa-envelope"></i>Mail<i class="fa-solid"></i></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                <i class="fa-solid fa-sun-plant-wilt"></i>Plan Type<i class="fa-solid"></i></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#">
                                <i class="fa-solid fa-user-nurse "></i>Insurance Master<i class="fa-solid"></i></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" routerLink="user">
                                <i class="fa-solid fa-users "></i>User Master<i class="fa-solid"></i></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="collapse" href="#settingsDropdown" role="button" aria-expanded="false" aria-controls="settingsDropdown">
                                <i class="fa-solid fa-gear"></i>Settings<i class="fa-solid fa-caret-down"></i></a>
                            <div class="collapse" id="settingsDropdown" >
                                <ul class="nav flex-column pl-3">
                                    <li class="nav-item">
                                        <a class="nav-link " (click)="openModal()">
                                            <i class="fa-solid fa-key"></i>Reset-Password<i class="fa-solid"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
        <div class="sidebar-footer">
            <button (click)="toggleSidebar()" class="btn btn-primary toggle-btn">
                <i class="fa-solid fa-minimize"></i>
            </button>
        </div>
    </aside>

</div>
<!-- sidebar -->
<div #resetPassword class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">Reset Password</h3>
                <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="resetPasswordForm" >
                    <div class="row">
                        <div class="col-xl-12 col-md-12 " >
                            <div class="form-group">
                                <mat-form-field appearance="outline">
                                    <mat-label>User-Name</mat-label>
                                    <input matInput formControlName="userName" minlength="3" pmNoSpace title="Name at least has 3 characters !">
                                    <mat-error *ngIf="resetPasswordForm.controls.userName.errors?.required">This field is required !</mat-error>
                                    <mat-error *ngIf="resetPasswordForm.controls.userName?.value">Name at least has 3 characters !</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-xl-12 col-md-12 ">
                            <div class="form-group">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Current Password</mat-label>
                                    <input matInput [type]="hidePassword ? 'password' : 'text'"
                                           formControlName="currentPassword" pmNoSpace pmPasswordPattern placeholder="Enter Password">
                                    <button *ngIf="resetPasswordForm.controls.currentPassword.value" mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility(1)">
                                        <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                    </button>
                                    <mat-error *ngIf="resetPasswordForm.controls.currentPassword.errors?.required">
                                        This field is required!
                                    </mat-error>
                                    <mat-error *ngIf="resetPasswordForm.controls.currentPassword.errors?.pattern">
                                        Password must be at least 8 characters, contain an uppercase letter, a lowercase letter, a number, and a special character.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-xl-12 col-md-12 ">
                            <div class="form-group">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>New Password</mat-label>
                                    <input matInput [type]="hideNewPassword ? 'password' : 'text'"
                                           formControlName="newPassword" pmNoSpace pmPasswordPattern placeholder="Enter Password">
                                    <button *ngIf="resetPasswordForm.controls.newPassword.value" mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility(2)">
                                        <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                    </button>
                                    <mat-error *ngIf="resetPasswordForm.controls.newPassword.errors?.required">
                                        This field is required!
                                    </mat-error>
                                    <mat-error *ngIf="resetPasswordForm.controls.newPassword.errors?.pattern">
                                        Password must be at least 8 characters, contain an uppercase letter, a lowercase letter, a number, and a special character.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-xl-12 col-md-12 ">
                            <div class="form-group">
                                <mat-form-field appearance="outline" class="full-width">
                                    <mat-label>Confirm Password</mat-label>
                                    <input matInput [type]="hideConfirmPassword ? 'password' : 'text'"
                                           formControlName="confirmPassword" pmNoSpace pmPasswordPattern placeholder="Enter Password">
                                    <button *ngIf="resetPasswordForm.controls.confirmPassword.value" mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility(3)">
                                        <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                                    </button>
                                    <mat-error *ngIf="resetPasswordForm.controls.confirmPassword.errors?.required">
                                        This field is required!
                                    </mat-error>
                                    <mat-error *ngIf="resetPasswordForm.get('confirmPassword')?.invalid" >
                                        Password must match.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button  type="submit" class="btn btn-primary" (click)="onSubmit()"  >Reset</button>
                <button type="button" class="btn btn-secondary" (click)="closeModal()">Close</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="this.authService.clientId === null">
    <div #CId class="modal-i" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Select Client</h3>
                    <!--<button type="button" class="close" aria-label="Close" (click)="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>-->
                </div>
                <div class="modal-body">
                    <form [formGroup]="cIdForm">
                        <div class="row">
                            <div class="col-xl-12 col-md-12 ">
                                <div class="form-group">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Client Id</mat-label>
                                        <mat-select formControlName="clientId" class="text-primary">
                                            <mat-option class="text-primary"
                                                        *ngFor="let items of clientList"
                                                        [value]="items.id">{{items.name}}</mat-option>
                                        </mat-select>
                                        <mat-error
                                                *ngIf="cIdForm.controls.clientId.errors?.required">
                                            This field is required !
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-danger" (click)="closeModali();this.authService.logout()">Back to login</button>
                    <button type="submit" class="btn btn-primary" (click)="onSubmitC()">Submit</button>
                </div>
            </div>
        </div>
    </div>
</div>

